import { render, staticRenderFns } from "./CphFooter.vue?vue&type=template&id=1c08e77b&scoped=true&"
import script from "./CphFooter.vue?vue&type=script&lang=js&"
export * from "./CphFooter.vue?vue&type=script&lang=js&"
import style0 from "./CphFooter.vue?vue&type=style&index=0&id=1c08e77b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c08e77b",
  null
  
)

export default component.exports